"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveSalesMeasureExportLabel = resolveSalesMeasureExportLabel;
const dbTableCampaign_1 = require("../../reporterDb/dbTableCampaign");
const columnTypes_1 = require("./columnTypes");
/** Synthetic `dataMappingId` / id prefix from Sales measures: `{sales|cpa}_{CPA|Count}_{random}`. */
const SALES_SYNTHETIC_PREFIX = /^(sales|cpa)_(?:CPA|Count)_/i;
function syntheticSalesEventIdFromMappingId(id) {
    if (!id)
        return undefined;
    const m = id.match(SALES_SYNTHETIC_PREFIX);
    if (!m)
        return undefined;
    return m[1].toLowerCase() === "cpa" ? dbTableCampaign_1.Metrics.cpa : dbTableCampaign_1.Events.sales;
}
function getSalesRelatedEventId(column) {
    const dataMappingId = column.dataMappingId;
    const isEventOrMetricColumn = !column.columnType ||
        [columnTypes_1.ColumnTypes.Event, columnTypes_1.ColumnTypes.Metric].includes(column.columnType);
    const isCohortedColumn = column.columnType === columnTypes_1.ColumnTypes.Cohorted;
    if (isEventOrMetricColumn) {
        return (column.eventId ||
            syntheticSalesEventIdFromMappingId(dataMappingId) ||
            syntheticSalesEventIdFromMappingId(column.id));
    }
    if (isCohortedColumn) {
        const c = column;
        return (c.eventId ||
            syntheticSalesEventIdFromMappingId(dataMappingId) ||
            syntheticSalesEventIdFromMappingId(column.id));
    }
    return undefined;
}
function calcTypeDisplay(eventId) {
    return eventId === dbTableCampaign_1.Metrics.cpa ? "CPA" : "Count";
}
const SALES_EVENT_IDS = [
    dbTableCampaign_1.Events.sales,
    dbTableCampaign_1.Metrics.cpa,
];
/**
 * CSV / export column title when synthetic Sales ids skip EVENTS_LABELED / METRICS_LABELED
 * and `column.label` is empty (e.g. older saved reports).
 */
function resolveSalesMeasureExportLabel(column) {
    const eventId = getSalesRelatedEventId(column);
    if (!eventId || !SALES_EVENT_IDS.includes(eventId)) {
        return undefined;
    }
    const calc = calcTypeDisplay(eventId);
    if (column.columnType === columnTypes_1.ColumnTypes.Cohorted) {
        return `Sales (Cohorted) (${calc})`;
    }
    return `Sales (${calc})`;
}
